export default __webpack_public_path__ + "be47ac8467d9697e27e37036c70e02e1.png";